module.exports = __webpack_public_path__ + "assets/img/logo.3d411ff6.png";